import { Flex, Heading, Text } from "@chakra-ui/react";
import React from "react";
import { Link } from "react-router-dom";

const Index = () => {
  return (
    <Flex direction="column">
      <Flex
        h="150px"
        backgroundColor="facebook.500"
        fontWeight="bold"
        fontSize="30px"
        align="center"
        justify="center"
      >
        <Heading fontFamily="sans-serif" color="lavenderblush">
          आनंद टेलर्स
        </Heading>
      </Flex>
      <Flex
        bg="cyan.400"
        h="60px"
        align="center"
        fontWeight="bold"
        justifyContent="space-between"
      >
        <Flex w="100%" justifyContent="center" fontWeight="bold" fontSize="20px">
          <Link to="/pant" style={{ margin: "0 20px" }}>
            <Text fontWeight="bold" fontSize="26px">
              {"पँट"}
            </Text>
          </Link>

          <Link to="/pantorder" style={{ margin: "0 20px" }}>
            <Text fontWeight="bold" fontSize="26px">
              {"पॅंटऑर्डर्स"}
            </Text>
          </Link>

          <Link to="/shirt" style={{ margin: "0 20px" }}>
            <Text fontWeight="bold" fontSize="26px">
              {"शर्ट"}
            </Text>
          </Link>

          <Link to="/shirtorder" style={{ margin: "0 20px" }}>
            <Text fontWeight="bold" fontSize="26px">
              {"शर्टऑर्डर्स"}
            </Text>
          </Link>

          <Link to="/order/add" style={{ margin: "0 20px" }}>
            <Text fontWeight="bold" fontSize="26px">
              {"तपशील"}
            </Text>
          </Link>

          <Link to="/orders" style={{ margin: "0 20px" }}>
            <Text fontWeight="bold" fontSize="26px">
              {"ऑर्डर्स"}
            </Text>
          </Link>

          <Link to="/customer" style={{ margin: "0 20px" }}>
            <Text fontWeight="bold" fontSize="26px">
              {"कस्टमर"}
            </Text>
          </Link>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default Index;
